import { statusLabel, statusTone } from "./template-status";

const TONE_CLASSES: Record<string, string> = {
  neutral: "bg-ink-100 text-ink-700",
  pending: "bg-amber-100 text-amber-800",
  good: "bg-emerald-100 text-emerald-800",
  warn: "bg-orange-100 text-orange-800",
  bad: "bg-red-100 text-red-800",
};

export function TemplateStatusBadge({
  status,
}: {
  status: string;
}): React.JSX.Element {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
        TONE_CLASSES[statusTone(status)] ?? TONE_CLASSES.neutral
      }`}
    >
      {statusLabel(status)}
    </span>
  );
}
